<template>
  <div class="platform-shell ps-shell">
    <svg class="menu-icon-sprite" aria-hidden="true" focusable="false">
      <symbol id="ps-icon-grid" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></symbol>
      <symbol id="ps-icon-city" viewBox="0 0 24 24"><path d="M3 21h18M5 21V8l7-4 7 4v13M8 10h2m4 0h2m-8 4h2m4 0h2m-8 4h2m4 0h2"/></symbol>
      <symbol id="ps-icon-compass" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="m15.5 8.5-2.2 4.8-4.8 2.2 2.2-4.8z"/></symbol>
      <symbol id="ps-icon-chart" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 16v-4M12 16V8M16 16v-6"/></symbol>
      <symbol id="ps-icon-trend" viewBox="0 0 24 24"><path d="M4 19V5M4 19h16m-13-4 3-3 3 2 5-6m-3 0h3v3"/></symbol>
      <symbol id="ps-icon-report" viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6zM15 3v4h4M9 11h6M9 15h6M9 18h4"/></symbol>
      <symbol id="ps-icon-bell" viewBox="0 0 24 24"><path d="M6 17h12l-1.5-2v-4a4.5 4.5 0 0 0-9 0v4zM10 20h4"/></symbol>
      <symbol id="ps-icon-puzzle" viewBox="0 0 24 24"><path d="M9 4h3a2 2 0 1 1 4 0h3v4a2 2 0 1 1 0 4v4h-4a2 2 0 1 1-4 0H7v-4a2 2 0 1 1 0-4V4z"/></symbol>
      <symbol id="ps-icon-map" viewBox="0 0 24 24"><path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3zM9 3v15M15 6v15"/></symbol>
      <symbol id="ps-icon-clipboard" viewBox="0 0 24 24"><rect x="5" y="5" width="14" height="16" rx="2"/><path d="M9 5V3h6v2M8 10h8M8 14h8M8 18h5"/></symbol>
      <symbol id="ps-icon-users" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3"/><path d="M3.5 20v-1.5A4.5 4.5 0 0 1 8 14h2a4.5 4.5 0 0 1 4.5 4.5V20M16 14h1a4 4 0 0 1 4 4v2M15 5.5a3 3 0 0 1 0 5.8"/></symbol>
      <symbol id="ps-icon-lock" viewBox="0 0 24 24"><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3"/></symbol>
      <symbol id="ps-icon-chevron" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></symbol>
      <symbol id="ps-icon-home" viewBox="0 0 24 24"><path d="m3 10 9-7 9 7M5 9.5V21h14V9.5M9 21v-6h6v6"/></symbol>
      <symbol id="ps-icon-exit" viewBox="0 0 24 24"><path d="M10 4H5v16h5M14 8l4 4-4 4M9 12h9"/></symbol>
      <symbol id="ps-icon-arrow" viewBox="0 0 24 24"><path d="M4 12h15m-5-5 5 5-5 5"/></symbol>
    </svg>
    <section class="workspace">
      <header class="workspace-header ps-header">
        <div class="ps-header-inner">
          <router-link to="/" class="ps-brand" aria-label="返回平台选择">
            <span class="ps-brand-mark"><img src="@/assets/login/community-model.png" alt="智慧城市网格化管理平台"></span>
            <span><strong>社区管理虚拟仿真沙盘</strong><small>COMMUNITY GOVERNANCE SIMULATION</small></span>
          </router-link>
          <div v-if="platform" class="ps-current-platform" :class="`is-${platform}`"><span></span>{{ platformName }}</div>
          <nav v-else ref="publicNavigation" class="ps-public-nav" aria-label="公共菜单">
            <div v-for="group in publicGroups" :key="group.key" class="ps-dropdown">
              <button type="button" class="ps-dropdown-trigger" :aria-expanded="String(openMenu === group.key)" :aria-controls="`ps-menu-${group.key}`" @click="toggleMenu(group.key)" @keydown.esc.stop="openMenu = null">
                <svg class="ps-icon"><use :href="`#ps-icon-${group.icon}`"/></svg>{{ group.label }}<svg class="ps-icon ps-chevron"><use href="#ps-icon-chevron"/></svg>
              </button>
              <div v-if="openMenu === group.key" :id="`ps-menu-${group.key}`" class="ps-dropdown-menu">
                <router-link v-for="item in group.items" :key="item.key" :to="item.to" @click.native="openMenu = null">{{ item.label }}</router-link>
              </div>
            </div>
          </nav>
          <div class="ps-account">
            <router-link v-if="platform && canViewNotifications" :to="{ name: 'notifications', query: { module: platform } }" class="ps-notification" :aria-label="notificationLabel" :title="notificationLabel">
              <svg class="ps-icon" aria-hidden="true"><use href="#ps-icon-bell"/></svg>
              <span v-if="unreadCount" class="ps-notification-badge" aria-hidden="true">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
            </router-link>
            <router-link v-if="$route.name !== 'home'" to="/" class="ps-switch"><svg class="ps-icon" aria-hidden="true"><use href="#ps-icon-home"/></svg>返回首页</router-link>
            <span class="ps-account-divider"></span><span class="ps-avatar" aria-hidden="true">{{ roleName.slice(0, 1) }}</span>
            <span class="ps-account-name">{{ userName }}</span><span class="ps-role">{{ roleName }}</span>
            <button type="button" class="ps-logout" @click="logout"><svg class="ps-icon"><use href="#ps-icon-exit"/></svg>退出</button>
          </div>
        </div>
      </header>
      <nav v-if="platform" class="ps-platform-nav" :aria-label="`${platformName}菜单`">
        <div class="ps-platform-nav-inner">
          <router-link v-for="item in platformItems" :key="item.key" :to="item.to" class="ps-platform-link" :class="{ 'is-active': item.key === activeMenu }" :aria-current="item.key === activeMenu ? 'page' : null">
            <svg class="ps-icon"><use :href="`#ps-icon-${item.icon}`"/></svg><span>{{ item.label }}</span>
          </router-link>
        </div>
      </nav>
      <main class="workspace-main" :class="{ 'workspace-main-wide': $route.name === 'network-run', 'ps-portal-main': $route.name === 'home' }"><router-view /></main>
    </section>
  </div>
</template>

<script>
import { activePlatformMenu, platformMenus, platformNames, publicMenuGroups, routePlatform } from '../services/platformNavigation'
import { can } from '../services/permissions'
import { api } from '../services/api'

export default {
  name: 'AppShell',
  data () { return { openMenu: null, permissionTimer: null, unreadCounts: {}, notificationSequence: 0 } },
  computed: {
    user () { return this.$store.state.currentUser || {} },
    userName () { return this.user.name || this.user.account || '未登录' },
    roleName () { return { ADMIN: '管理员', TEACHER: '教师', STUDENT: '学生' }[this.user.role] || '用户' },
    platform () { return routePlatform(this.$route, this.user) },
    platformName () { return platformNames[this.platform] || '' },
    platformItems () { return this.platform ? platformMenus(this.user, this.platform) : [] },
    publicGroups () { return publicMenuGroups(this.user) },
    activeMenu () { return activePlatformMenu(this.$route, this.user) },
    canViewNotifications () { return can(this.user, 'NOTIFICATION_VIEW') },
    unreadCount () { return Math.max(0, Number(this.unreadCounts[this.platform]) || 0) },
    notificationLabel () { return this.platformName + '通知消息' + (this.unreadCount ? '，' + this.unreadCount + '条未读' : '，暂无未读') }
  },
  watch: {
    '$route' () { this.openMenu = null; this.refreshUnread() },
    'user.id' () { this.unreadCounts = {}; this.refreshUnread() }
  },
  mounted () {
    document.addEventListener('click', this.closeOutside)
    document.addEventListener('visibilitychange', this.refreshUnread)
    window.addEventListener('focus', this.refreshHeader)
    window.addEventListener('notification-status-changed', this.refreshUnread)
    this.permissionTimer = window.setInterval(this.refreshHeader, 30000)
    this.refreshUnread()
  },
  beforeDestroy () {
    this.notificationSequence++
    document.removeEventListener('click', this.closeOutside)
    document.removeEventListener('visibilitychange', this.refreshUnread)
    window.removeEventListener('focus', this.refreshHeader)
    window.removeEventListener('notification-status-changed', this.refreshUnread)
    window.clearInterval(this.permissionTimer)
  },
  methods: {
    toggleMenu (key) { this.openMenu = this.openMenu === key ? null : key },
    closeOutside (event) { if (this.$refs.publicNavigation && !this.$refs.publicNavigation.contains(event.target)) this.openMenu = null },
    refreshPermissions () { if (!document.hidden) this.$store.dispatch('refreshCurrentUser').catch(() => {}) },
    refreshHeader () { this.refreshPermissions(); this.refreshUnread() },
    async refreshUnread () {
      const sequence = ++this.notificationSequence
      if (!this.platform || !this.canViewNotifications || !this.user.id || document.hidden) return
      const userId = this.user.id
      try {
        const counts = await api.get('/notifications/unread-count')
        if (sequence === this.notificationSequence && userId === this.user.id) this.unreadCounts = counts || {}
      } catch (_) { /* 保留上次结果，稍后重试 */ }
    },
    async logout () { try { await this.$store.dispatch('logout') } catch (_) {} finally { this.$router.push('/login').catch(() => {}) } }
  }
}
</script>
